import React, { useState, useEffect } from "react";
import ContainerComAbas from "../ui/Container/ContainerComAbas";
import ButtonVoltar from "../ui/Button/ButtonVoltar";
import ButtonSalvar from "../ui/Button/ButtonSalvar";
import DadosCliente from "./DadosCliente/DadosCliente";
import Endereco from "./Endereco/Endereco";
import BlocoAnotacoes from "./BlocoAnotacoes/BlocoAnotacoes";

import { inserirCliente, atualizarCliente } from "../Services/Cliente/clienteService";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Helmet } from "react-helmet";

export default function FormularioCliente({ clienteEdicao, onVoltar, onSalvar }) {
  const tabs = [
    { id: "dados", label: "Dados do Cliente" },
    { id: "bloco", label: "Bloco de Anotações" },
  ];

  const [activeTab, setActiveTab] = useState("dados");

  const [dadosCliente, setDadosCliente] = useState({
    nomeFantasia: "",
    razaoSocial: "",
    cpfCnpj: "",
    email: "",
    telefone: "",
  });

  const [endereco, setEndereco] = useState({
    cep: "",
    logradouro: "",
    numero: "",
    bairro: "",
    cidade: "",
    uf: "",
  });

  const [anotacao, setAnotacao] = useState("");
  const [salvando, setSalvando] = useState(false);

  // Preenche dados ao editar
  useEffect(() => {
    if (clienteEdicao) {
      setDadosCliente({
        nomeFantasia: clienteEdicao.nomeFantasia || "",
        razaoSocial: clienteEdicao.razaoSocial || "",
        cpfCnpj: clienteEdicao.cpfCnpj || "",
        email: clienteEdicao.email || "",
        telefone: clienteEdicao.telefone || "",
      });

      setEndereco({
        cep: clienteEdicao.cep || "",
        logradouro: clienteEdicao.logradouro || "",
        numero: clienteEdicao.numero || "",
        bairro: clienteEdicao.bairro || "",
        cidade: clienteEdicao.cidade || "",
        uf: clienteEdicao.uf || "",
      });

      setAnotacao(clienteEdicao.anotacao || "");
    }
  }, [clienteEdicao]);

  const toastStyle = {
    background: "#f9fafb",
    color: "#333",
    border: "1px solid #ddd",
    borderRadius: "0px",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "14px",
    boxShadow: "none",
    padding: "10px 16px",
  };

  const validarCampos = () => {
    if (!dadosCliente.nomeFantasia || !dadosCliente.razaoSocial || !dadosCliente.cpfCnpj || !dadosCliente.telefone) {
      toast.error("Por favor, preencha todos os campos obrigatórios.", {
        position: "top-right",
        autoClose: 3500,
        style: { ...toastStyle, border: "1px solid #fca5a5", color: "#b91c1c" },
        icon: "⚠️",
      });
      return false;
    }
    return true;
  };

  const handleSalvar = async () => {
    if (!validarCampos()) return;

    const dadosCompletos = {
      ...dadosCliente,
      ...endereco,
      anotacao,
      id: clienteEdicao?.id,
    };

    try {
      setSalvando(true);

      let resposta;

      if (clienteEdicao) {
        resposta = await atualizarCliente(dadosCompletos);
        toast.success("Cliente atualizado com sucesso!", {
          position: "top-right",
          autoClose: 2500,
          style: toastStyle,
          icon: "✅",
        });
      } else {
        resposta = await inserirCliente(dadosCompletos);
        toast.success("Cliente salvo com sucesso!", {
          position: "top-right",
          autoClose: 2500,
          style: toastStyle,
          icon: "✅",
        });
      }

      if (onSalvar) onSalvar(resposta);

    } catch (erro) {
      toast.error(
        erro?.message || erro?.erro || "Erro ao salvar cliente. Tente novamente.",
        {
          position: "top-right",
          autoClose: 3500,
          style: { ...toastStyle, border: "1px solid #fca5a5", color: "#b91c1c" },
          icon: "⚠️",
        }
      );
    } finally {
      setSalvando(false);
    }
  };

  return (
    <>
      {/* 🔹 Importando Comfortaa SOMENTE para este componente */}
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Comfortaa:wght@300..700&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <ToastContainer />

      <ContainerComAbas
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      >
        {/* 🔹 Fonte aplicada no formulário todo */}
        <div
          className="bg-white"
          style={{ fontFamily: "Comfortaa, cursive" }}
        >
          <div className="flex justify-end items-center gap-3 px-6 py-3">
            <ButtonVoltar onClick={onVoltar} texto="Voltar" />
            <ButtonSalvar
              onClick={handleSalvar}
              texto={salvando ? "Salvando..." : "Salvar"}
              disabled={salvando}
            />
          </div>

          {activeTab === "dados" && (
            <div className="mt-5 px-6 pb-6">
              <DadosCliente dados={dadosCliente} setDados={setDadosCliente} />
              <Endereco endereco={endereco} setEndereco={setEndereco} />
            </div>
          )}

          {activeTab === "bloco" && (
            <div className="mt-5 px-6 pb-6">
              <BlocoAnotacoes anotacao={anotacao} setAnotacao={setAnotacao} />
            </div>
          )}
        </div>
      </ContainerComAbas>
    </>
  );
}
